import { MetricOption, MetricType } from 'components/common/types/DrilldownReports.types';

export const metricTypeToName: Record<MetricType, string> = {
  [MetricType.IMPRESSIONS]: 'Impressions',
  [MetricType.FRAMES]: 'Frames',
  [MetricType.SOT]: 'SOT',
  [MetricType.PRICE_GROSS]: 'Price (Gross)',
  [MetricType.PRICE_INDEXED]: 'Price (Indexed)',
  // [MetricType.REPETITIONS]: 'Repetitions',
  [MetricType.DELIVERED_IMPRESSIONS]: 'Delivered Impressions',
  [MetricType.DELIVERED_SOT]: 'Delivered SOT',
  // [MetricType.DELIVERED_PRICE_GROSS]: 'Delivered Price (Gross)',
  // [MetricType.DELIVERED_PRICE_INDEXED]: 'Delivered Price (Indexed)',
  [MetricType.DELIVERED_PLAYS]: 'Delivered Repetitions',
};

export const metricOptions: MetricOption[] = [
  { name: metricTypeToName[MetricType.IMPRESSIONS], code: MetricType.IMPRESSIONS },
  { name: metricTypeToName[MetricType.FRAMES], code: MetricType.FRAMES },
  { name: metricTypeToName[MetricType.SOT], code: MetricType.SOT },
];

export const allocationMetricOptions: MetricOption[] = [
  ...metricOptions,
  { name: metricTypeToName[MetricType.PRICE_GROSS], code: MetricType.PRICE_GROSS },
  { name: metricTypeToName[MetricType.PRICE_INDEXED], code: MetricType.PRICE_INDEXED },
  // { name: metricTypeToName[MetricType.REPETITIONS], code: MetricType.REPETITIONS },
];

export const deliveredMetricOptions: MetricOption[] = [
  { name: metricTypeToName[MetricType.DELIVERED_IMPRESSIONS], code: MetricType.DELIVERED_IMPRESSIONS },
  { name: metricTypeToName[MetricType.DELIVERED_SOT], code: MetricType.DELIVERED_SOT },
  // { name: metricTypeToName[MetricType.DELIVERED_PRICE_GROSS], code: MetricType.DELIVERED_PRICE_GROSS },
  // { name: metricTypeToName[MetricType.DELIVERED_PRICE_INDEXED], code: MetricType.DELIVERED_PRICE_INDEXED },
  { name: metricTypeToName[MetricType.DELIVERED_PLAYS], code: MetricType.DELIVERED_PLAYS },
];
